export default __webpack_public_path__ + "static/media/SCN-NONGST-Template.2573935e.xlsx";